import AddBonanzaPointForm from './addBonanzaPointForm.container'

export default AddBonanzaPointForm